import React from 'react';

import { SearchField, DropdownFilter } from '/components/producer-search/components';

const ProducerSearchFilters = () => (
    <div className="producer-search-filters">
        <SearchField />
        <DropdownFilter
            label="Filter op locatie"
            singular="locatie geselecteerd"
            plural="locaties geselecteerd"
            attribute="facets.locations"
        />
        <DropdownFilter
            label="Filter op producten"
            singular="product geselecteerd"
            plural="producten geselecteerd"
            attribute="facets.products"
        />
    </div>
);

export { ProducerSearchFilters };
